const apiDomain = Laravel.apiDomain;
export const siteName = Laravel.siteName;

export const wiseAiAPI = Laravel.wise_api_url;

export const api = {
	login: apiDomain + '/login',
	register: apiDomain + '/register',
	phone_country_codes: apiDomain + '/phone-country-codes/get',
	investor_registration_constants: apiDomain + '/investor-registration-constants/get',
	logout: apiDomain + '/logout',
	currentUser: apiDomain + '/user/current',
	user_info: apiDomain + '/user/info',
	register_verify: apiDomain + '/register/verify',
	resend_register_verify: apiDomain + '/register/resend-verification',
    download: apiDomain + '/download',

	password_change: apiDomain + '/user/change-password',
	password_reset: apiDomain + '/password/reset',
	password_reset_new: apiDomain + '/password/new',

	get_two_factor: apiDomain + '/user/get-two-factor',
	get_qr_code: apiDomain + '/user/get-qr-code',
	authenticate_two_factor: apiDomain + '/user/authenticate-two-factor',
	reset_authenticator_mail: apiDomain + '/user/reset-two-factor-mail',
	reset_authenticator: apiDomain + '/user/reset-two-factor',
	send_email_otp: apiDomain + '/user/send-email-otp',

	investors : {
		check_application: apiDomain + '/investors/check/applications',
		apply: apiDomain + '/investors/apply',
		withdraw: apiDomain + '/investors/withdraw',
		topup: apiDomain + '/investors/topup',
		new_investment: apiDomain + '/investors/investment',
		verify_latest_topup: apiDomain + '/investors/verify_latest_topup',
		premium_upgrade: apiDomain + '/investors/new_premium_upgrade',
		get_investor_risk_settings: apiDomain + '/investors/get_investor_risk_settings',
		update_investor_risk_settings: apiDomain + '/investors/update_investor_risk_settings'
	},

	business_owners: {
		check_application: apiDomain + '/business_owners/check/applications',
		apply: apiDomain + '/business_owners/apply',
		log_application: apiDomain + '/business_owners/log/application',
		save_draft: apiDomain + '/business_owners/save/draft',
		retrieve_draft: apiDomain + '/business_owners/retrieve/draft',
		financing_apply: apiDomain + '/business_owners/financing/apply',
		log_financing_application: apiDomain + '/business_owners/log/financing',
		save_financing_draft: apiDomain + '/business_owners/financing/save/draft',
		retrieve_financing_draft: apiDomain + '/business_owners/financing/retrieve/draft',
	},

    dashboard: {
	    // business owner
	    data_ongoing_note: apiDomain + '/dashboard/data/ongoing_notes',
        data_recent_activities: apiDomain + '/dashboard/data/recent_activities',
		data_bo_principal_outstanding: apiDomain + '/dashboard/data/bo/stats',
		data_bo_monthly_repayment: apiDomain + '/dashboard/data/bo/monthly_repayment', // similar to investment return

        // investor
		data_investor_statistics: apiDomain + '/dashboard/data/investor/stats',
		data_investor_platform_financials: apiDomain + '/dashboard/data/investor/platform_financials',
		data_investor_monthly_repayment: apiDomain + '/dashboard/data/investor/monthly_repayment',
		data_investor_withdrawals_deposits: apiDomain + '/dashboard/data/investor/withdrawals_deposits',
		data_investor_notes_subscribed: apiDomain + '/dashboard/data/investor/notes_subscribed',
		data_investor_investment_return: apiDomain + '/dashboard/data/investor/investment_return', // similar to bo monthly repayment
    },

	notifications : {
		data_notifications:  apiDomain + '/notifications/data',
	},

	// Notes routes
	notes: {
		// General
		note_detailed: apiDomain + '/notes/',
		note_amortizations: apiDomain + '/notes/amortizations',
		note_financials: apiDomain + '/notes/financials',

		// Investor Only data
		data_notes_open_for_subscription: apiDomain + '/notes/data/open_for_subscription',
		data_open_for_subscription_minimised: apiDomain + '/notes/data/open_for_subscription_minimised',
		data_notes_subscribed: apiDomain + '/notes/data/subscribed',
		data_notes_past: apiDomain + '/notes/data/past',
		data_note_updates:apiDomain + '/notes/data/updates',

		// BO only data
		data_notes_bo_pending: apiDomain + '/notes/data/bo/pending',
		data_notes_bo_listed: apiDomain + '/notes/data/bo/listed',
		data_notes_bo_issued: apiDomain + '/notes/data/bo/issued',
		data_notes_bo_defaulted: apiDomain + '/notes/data/bo/defaulted',
		data_notes_bo_completed: apiDomain + '/notes/data/bo/completed',
		data_notes_under_review: apiDomain + '/notes/data/bo/under_review',

		// BO / Investor data
		data_notes_ledger: apiDomain + '/notes/data/ledger',

		// BO Notes actions
		confirm_listing: apiDomain + '/notes/listing/confirm',
		issue: apiDomain + '/notes/issue',
		submit_additional_documents: apiDomain + '/notes/submit_additional_documents',
		get_note_next_payment: apiDomain + '/notes/bo/next_payment',
		note_payment: apiDomain + '/notes/bo/pay',
		note_payment_check: apiDomain + '/notes/bo/payment/check',
	},

	my_activity: {
		data_my_activity: apiDomain + '/my_activity/data',
        generate_statement: apiDomain + '/my_activity/statement',
		data_get_my_notes: apiDomain + '/my_activity/data/get_my_notes'
	}
};
